<div style="padding: 50px;">
	Select a component above to view diagnostic information
</div>